/* @flow */

export function gridTemplate(cols: string, rows: string): Object {
  return {
    gridTemplateColumns: cols,
    gridTemplateRows: rows,
    MsGridColumns: cols,
    MsGridRows: rows,
  };
}

export function gridStart(col: number, row: number): Object {
  return {
    gridColumnStart: col,
    gridRowStart: row,
    MsGridColumn: col,
    MsGridRow: row,
  };
}
